<template>
  <div v-if="!isAuthenticated">
    <slot /> <!-- login o rutas públicas -->
  </div>

  <div v-else-if="cargando" class="text-center py-5">
    <p>Cargando información del usuario...</p>
  </div>

  <!-- ⚙️ Paso de selección -->
  <div v-else-if="!opcionElegida" class="container py-5 text-center">
    <h4 class="mb-4">¿Cómo querés empezar?</h4>
    <div class="row justify-content-center g-4">
      <!-- Opción: Crear club -->
      <div class="col-md-5">
        <div class="card h-100 shadow-sm border-success opcion-card" @click="elegirOpcion('crear')">
          <div class="card-body text-center">
            <font-awesome-icon :icon="['fas', 'leaf']" class="mb-3 fs-2 text-success" />
            <h5 class="card-title mb-2">Crear nuevo club</h5>
            <p class="card-text">Pagá una suscripción mensual y comenzá tu gestión desde cero.</p>
            <button class="btn btn-success mt-2">Comenzar</button>
          </div>
        </div>
      </div>

      <!-- Opción: Ya tengo un club -->
      <div class="col-md-5">
        <div class="card h-100 shadow-sm border-secondary opcion-card" @click="elegirOpcion('esperar')">
          <div class="card-body text-center">
            <font-awesome-icon :icon="['fas', 'users']" class="mb-3 fs-2 text-secondary" />
            <h5 class="card-title mb-2">Ya tengo un club</h5>
            <p class="card-text">Esperá que el administrador del club te vincule desde su panel.</p>
            <button class="btn btn-outline-secondary mt-2">Esperar vinculación</button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- ✅ Mostrar pasos solo si eligió crear -->
  <div v-else-if="opcionElegida === 'crear' && paso !== 'COMPLETO'"
    class="onboarding-wrapper container-fluid px-2 d-flex flex-column flex-md-row justify-content-center align-items-start gap-4">
    <!-- Paso 1: Crear Club -->
    <div :class="[
      'step-card',
      paso === 'CREAR_CLUB' ? 'active-step full-width' : 'inactive-step'
    ]">
      <CrearClub @club-creado="fetchPasoActual" />
    </div>

    <!-- Paso 2: Pagar Suscripción -->
    <div :class="[
      'step-card',
      paso === 'PAGO_SUSCRIPCION' ? 'active-step full-width' : 'inactive-step'
    ]">
      <PagarSuscripcion @pago-exitoso="fetchPasoActual" />
    </div>
  </div>

  <!-- 💬 Mensaje si espera ser vinculado -->
  <div v-else-if="opcionElegida === 'esperar'" class="text-center py-5">
    <div class="alert alert-info p-4 text-center" style="max-width: 600px; margin: auto;">
      <h4 class="mb-3">
        <font-awesome-icon :icon="['fas', 'users']" class="me-2 text-primary" />
        Estás esperando ser vinculado a un club
      </h4>
      <p class="mb-3">
        Tu cuenta fue creada correctamente, pero aún no estás vinculado a un club.
        Esto lo realiza el responsable del club desde el sistema.
      </p>
      <p class="fw-bold">
        Contactá por <span class="text-success">WhatsApp</span>, <span class="text-success">email</span> o en persona al
        encargado del club para que te vincule.
      </p>
      <p class="text-muted fst-italic mt-3">
        Una vez que seas vinculado, vas a poder acceder a las tareas, proyectos y datos del club.
      </p>
      <button class="btn btn-outline-primary mt-3" @click="elegirOpcion(null)">Volver atrás</button>
    </div>
  </div>

  <!-- ✅ Mostrar aplicación principal después -->
  <div v-else>
    <slot />
  </div>
</template>

<script>
import CrearClub from '@/components/Club/alta-club.vue'
import PagarSuscripcion from '@/views/MercadoPago/MercadoPagoView.vue'
import axios from '@/axios'

export default {
  name: 'OnboardingWrapper',
  components: { CrearClub, PagarSuscripcion },
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      paso: null,
      cargando: false,
      mostrarManual: false,
      opcionElegida: null // 👈 Nueva variable
    }
  },
  watch: {
    async isAuthenticated(nuevoValor) {
      if (nuevoValor) {
        this.cargando = true
        await this.fetchPasoActual()
        this.cargando = false
      } else {
        this.paso = null
      }
    }
  },
  async created() {
    if (this.isAuthenticated) {
      this.cargando = true
      await this.fetchPasoActual()
      this.cargando = false
    }
  },
  mounted() {
    if (this.isAuthenticated) {
      this.cargando = true
      this.fetchPasoActual()
      this.opcionElegida = null
      this.cargando = false
    }
  },
  methods: {
    async fetchPasoActual() {
      try {
        const res = await axios.get('/api/onboarding_status')
        this.paso = res.data.paso_actual
        if (this.paso === 'COMPLETO') {
          this.mostrarManual = true
          this.opcionElegida = 'crear' // 👈 Fix agregado
        }
      } catch (error) {
        console.warn('Error al obtener estado de onboarding:', error)
        this.paso = 'COMPLETO'
        this.mostrarManual = true
        this.opcionElegida = 'crear' // 👈 También aquí para fallback
      }
    },
    elegirOpcion(valor) {
      this.opcionElegida = valor
    }
  }
}
</script>


<style scoped>
.onboarding-wrapper {
  padding: 2rem 0.5rem;
  flex-wrap: wrap;
}

.step-card {
  width: 100%;
  max-width: 100%;
  /* 🔁 ahora ocupa todo */
}


.active-step {
  transform: scale(1.02);
  z-index: 10;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
  background: white;
  border: 2px solid #198754;
}

.inactive-step {
  opacity: 0.6;
  transform: scale(0.96);
  background: #f8f9fa;
  border: 1px dashed #ccc;
}

.full-width {
  padding: 0 !important;
  margin: 0 auto !important;
  width: 100%;
}

@media (min-width: 768px) {
  .full-width {
    width: 40%;
  }
}
</style>
